export default __webpack_public_path__ + "static/media/web_badge.0edf066b.svg";